const a = {
  id: "NebraskaPick5",
  name: "Pick 5",
  style: {
    colorPrimary: "#6446a1"
  }
};
export {
  a as default
};
